import { createReducer, on } from '@ngrx/store';
import { User } from '@/model/user';
import * as UserActions from './user.actions';

export interface UserState {
  user: User | null;
  loading: boolean;
  error: string | null;
}

export const initialState: UserState = {
  user: null,
  loading: false,
  error: null,
};

export const userReducer = createReducer(
  initialState,
  on(UserActions.loadUser, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(UserActions.loadUserSuccess, (state, { user }) => ({
    ...state,
    user,
    loading: false,
  })),
  on(UserActions.loadUserFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error: typeof error === 'string' ? error : 'Failed to load user',
  })),
  on(UserActions.clearUser, () => ({
    ...initialState,
  })),
);
